import { defineComponent as _defineComponent } from 'vue'
import { Customer } from '@/models/tenant';
import { AlertOperator } from '@/models/enums/AlertsEnums';
import TableActionButton from '@/components/tableWithActions/TableActionButton.vue';
import TableWithActions from '@/components/tableWithActions/TableWithActions.vue';
import { dialogService } from '@/library-services/dialog.service';
import { modalService } from '@/library-services/modal.service';
import { getCurrentInstance, onBeforeMount, ref } from 'vue';
import { useI18n } from '@/composables/i18n';
import AlertFormModal from '@/components/alerts/AlertFormModal.vue';
import { WccAlert } from '@/models/wccAlert';
import { workCenterAlertsService } from '@/services/workCenterAlerts.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerAlerts',
  props: {
    customer: null
  },
  setup(__props: any) {

const props = __props as {
  customer: Customer;
};



const { t } = useI18n();

const app = getCurrentInstance();
const alerts = ref<WccAlert[]>([]);
const isLoading = ref(false);

onBeforeMount(async () => {
  await getAlerts();
});

async function getAlerts() {
  isLoading.value = true;
  workCenterAlertsService
    .getAllByCustomerId(props.customer.id)
    .then((response) => (alerts.value = response))
    .finally(() => (isLoading.value = false));
}

function confirmDelete(alert: WccAlert): void {
  dialogService.confirmWithPromise({
    title: t('dialog.confirm_title').toString(),
    message:
      t('action.delete').toString() +
      ` <b>${t(`alert.metric.${alert.metric}`)} ${t(
        `alert_operators.${AlertOperator[alert.operator]}`,
      )} ${alert.threshold} ${alert.deviceName ?? t(`alert.all_devices`)}</b>?`,
    confirmText: t('dialog.confirm_delete').toString(),
    cancelText: t(`dialog.confirm_cancel`).toString(),
    type: 'is-danger',
    onConfirm: async () => await deleteAlert(alert.id!),
  });
}

async function createAlert() {
  modalService.compositionApi.open(
    {
      component: AlertFormModal,
      props: {
        customer: props.customer,
      },
      events: {
        save: () => getAlerts(),
      },
    },
    app,
  );
}

async function updateAlert(alert: WccAlert) {
  modalService.compositionApi.open(
    {
      component: AlertFormModal,
      props: {
        alert,
        customer: props.customer,
      },
      events: {
        save: () => getAlerts(),
      },
    },
    app,
  );
}

async function deleteAlert(alertId: number) {
  await workCenterAlertsService.delete(alertId).then(() => {
    alerts.value = alerts.value.filter((alert) => alert.id !== alertId);
  });
}

function getDeviceName(alert: WccAlert) {
  return alert.deviceName ?? t(`alert.all_devices`);
}

function getMetric(alert: WccAlert) {
  return t(`alert.metric.${alert.metric}`);
}

function getOperator(alert: WccAlert) {
  return t(`alert_operators.${AlertOperator[alert.operator]}`);
}

function getAction(alert: WccAlert) {
  return t(`alert.action.${alert.action}`);
}

return { __sfc: true,props, t, app, alerts, isLoading, getAlerts, confirmDelete, createAlert, updateAlert, deleteAlert, getDeviceName, getMetric, getOperator, getAction, TableActionButton, TableWithActions }
}

})